import Vue from 'vue'
import FileUpload from 'vue-upload-component'

Vue.component('file-upload', FileUpload)
